<template>
  <div
    class="hero is-fullheight fullpage-section"
    data-anchor="section-fabricacion"
  >
    <div
      class="column is-portrait height100 is-paddingless"
      v-bind:class="{
        'background-fabricacion-1': indexFabricacion === 0,
        'background-fabricacion-2': indexFabricacion === 1,
        'background-fabricacion-3': indexFabricacion === 2,
        'background-fabricacion-mobile-1': backFabricacionMobile === true,
        'background-fabricacion-mobile-2': backFabricacionMobile === false
      }"
    >
      <div class="columns fabricacion-content">
        <div class="column is-6-desktop is-12-touch">
          <div
            class="column is-half height10-touch
                  orange-color has-font-unica is-size-2 height20"
            align="center"
          >
            <p class="is-hidden-desktop">FABRICACIÓN</p>
          </div>
          <div class="columns is-mobile is-centered" align="center">
            <div class="column is-2-desktop is-3-touch ">
              <img
                class="is-hidden-touch"
                :src="getImg('Fabricacion/flecha-superior-izq.png')"
                alt=""
                v-on:click="
                  (indexFabricacion = (indexFabricacion - 1 + 3) % 3),
                    titleActualTxt(),
                    descriptionActualTxt()
                "
              />
              <img
                class="is-hidden-desktop"
                :src="getImg('Fabricacion/Flecha-Izquierda.png')"
                alt=""
                v-on:click="
                  (indexFabricacion = (indexFabricacion - 1 + 3) % 3),
                    (backFabricacionMobile = !backFabricacionMobile),
                    titleActualTxt(),
                    descriptionActualTxt()
                "
              />
            </div>
            <div class="column is-5-desktop is-6-touch">
              <img
                class="img-fabricacion"
                :src="iconoActualImg(indexFabricacion)"
                alt=""
              />
              <div
                class="column is-size-3 is-size-5-touch white-color mobile-elements-color"
                id="titles"
                align="center"
                style="font-weight: bold"
                onload="titleActualTxt()"
              >
                DISEÑO DE LA <br class="is-hidden-touch" />
                FUNDA
              </div>
            </div>
            <div class="column is-2-desktop is-3-touch">
              <img
                class="is-hidden-touch"
                :src="getImg('Fabricacion/flecha-superior-der.png')"
                alt=""
                v-on:click="
                  (indexFabricacion = (indexFabricacion + 1 + 3) % 3),
                    titleActualTxt(),
                    descriptionActualTxt()
                "
              />
              <img
                class="is-hidden-desktop"
                :src="getImg('Fabricacion/Flecha-Derecha.png')"
                alt=""
                v-on:click="
                  (indexFabricacion = (indexFabricacion + 1 + 3) % 3),
                    (backFabricacionMobile = !backFabricacionMobile),
                    titleActualTxt(),
                    descriptionActualTxt()
                "
              />
            </div>
          </div>
        </div>
        <div
          class="column is-6-desktop"
          align="center"
          style="position: relative"
        >
          <div class="column is-half is-hidden-touch height15"></div>
          <div
            class="column is-8-desktop white-background full-center height70-portrait"
          >
            <div class="column is-paddingless is-hidden-touch height20">
              <p class="orange-color has-font-unica is-size-2">FABRICACIÓN</p>
            </div>
            <div
              class="column white-background is-size-5 is-size-6-touch"
              id="descriFabricacion"
              align="center"
              onload="descriptionActualTxt()"
            >
              El diseño de la funda se realiza a<br />
              través de las medidas tomadas<br />
              al paciente, para generar una<br />
              mayor personalización en la<br />
              forma y contextura. <br /><br />

              Posteriormente se diseña la<br />
              funda en software 3D.
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getImg } from '@/utils/assets-helpers'

export default {
  name: 'Fabricacion',
  methods: {
    getImg,
    iconoActualImg(indexFabricacion) {
      return getImg(this.iconos[indexFabricacion])
    },
    descriptionActualTxt() {
      document.getElementById(
        'descriFabricacion'
      ).innerHTML = this.descriFabricacion[this.indexFabricacion]
    },
    titleActualTxt() {
      document.getElementById('titles').innerHTML = this.titles[
        this.indexFabricacion
      ]
    }
  },
  data: function() {
    return {
      flechas: [
        'Fabricacion/flecha-superior-der.png',
        'Fabricacion/flecha-superior-izq.png'
      ],
      iconos: [
        'Fabricacion/icono-diseño.png',
        'Fabricacion/icono-impresion.png',
        'Fabricacion/icono-funda.png'
      ],
      titles: [
        'DISEÑO DE LA FUNDA',
        'IMPRESIÓN DE LA FUNDA',
        'TERMINACIÓN DE LA FUNDA'
      ],
      indexFabricacion: 0,
      backFabricacionMobile: true,
      descriFabricacion: [
        'El diseño de la funda se realiza a<br />\n' +
          'través de las medidas tomadas<br />\n' +
          'al paciente, para generar una<br />\n' +
          'mayor personalización en la<br />\n' +
          'forma y contextura. <br /><br />\n' +
          '\n' +
          'Posteriormente se diseña la<br />\n' +
          'funda en software 3D.',
        'La impresión de la funda se<br />\n' +
          'realiza en materiales<br />\n' +
          'ya testeados mecánicamente<br />\n' +
          'para comprobar su resistencia.<br /><br />\n' +
          '\n' +
          'La funda se imprime en el<br />\n' +
          'laboratorio de CALCE para<br />\n' +
          'tener un mejor control de<br />\n' +
          'todo el proceso.',
        'Calce posee variadas<br />\n' +
          'opciones en el diseño de su<br />\n' +
          'terminación superficial.<br /><br />\n' +
          '\n' +
          'Tenemos a disponibilidad<br />\n' +
          'colores sólidos y con<br />\n' +
          'patrones, pudiendo ser el<br />\n' +
          'acabado brillante o mate.'
      ]
    }
  }
}
</script>

<style scoped>
.fabricacion-content {
  height: 100vh;
}

.height20 {
  height: 20vh;
}

.height15 {
  height: 15vh;
}

.full-center {
  align-items: center;
  align-content: center;
  align-self: center;
  justify-content: center;
  justify-items: center;
  justify-self: center;
}

.img-fabricacion {
  width: 60vw;
  height: auto;
}

.orange-color {
  color: #f39e52;
}

.white-background {
  background-color: rgba(255, 255, 255, 0.6);
}

@media screen and (orientation: portrait) {
  .background-fabricacion-mobile-1 {
    background-image: url('../assets/img/Fabricacion/fondo-fabricacion-mobile.jpg');
    background-size: cover;
  }
  .background-fabricacion-mobile-2 {
    background-image: url('../assets/img/Fabricacion/fondo-fabricacion2-mobile.png');
    background-size: cover;
  }
  .background-color-elements {
    background-color: #00adee;
  }
  .mobile-elements-color {
    color: #00adee;
  }
}

@media screen and (max-width: 1087px) {
  .height10-touch {
    height: 10vh !important;
  }
}

@media screen and (orientation: landscape) {
  .height70-landscape {
    height: 70vh;
  }
  .background-fabricacion-1 {
    background-image: url('../assets/img/Fabricacion/fondo-fabricacion.png');
    background-size: cover;
  }
  .background-fabricacion-2 {
    background-image: url('../assets/img/Fabricacion/fondo-fabricacion2.png');
    background-size: cover;
  }
  .background-fabricacion-3 {
    background-image: url('../assets/img/Fabricacion/fondo-fabricacion3.png');
    background-size: cover;
  }
}
</style>
